import React from "react";
import { Step, Stepper, StepLabel, createTheme, ThemeProvider } from "@material-ui/core";
import { grey } from "@material-ui/core/colors";

import { useHistory } from "react-router-dom";
import { useApplicationState } from "../../../state/store/customHooks";
import { URI_PATHS, IS_MOBILE } from "../../../constants";

const theme = createTheme({
  overrides: {
    MuiStepper: {
      root: {
        backgroundColor: grey[50],
        width: IS_MOBILE ? "80%" : "50%",
        display: "inline-flex",
      },
    },
    MuiStepIcon: {
      root: {
        '&$completed': {
          color: "#26e3ba",
        },
        '&$active': {
          color: "#26e3ba",
        },
      },
    },
    MuiTypography: {
      body2: {
        fontSize: ".8rem",
      },
    },
  },
});

const StepperV2 = () => {
  const history = useHistory();
  const onDecisionPage = history.location.pathname.includes(URI_PATHS.DECISION);
  const stepOrder = useApplicationState("stepOrder");

  // need to subtract by 1 here since we're getting rid of showing basic info
  const currentStepIndex = useApplicationState("currentStepIndex") - 1;

  const totalSteps = stepOrder
    .slice(1, stepOrder.length)   // get rid of showing basic info
    .map((step) => {
      return (
        <Step key={step} >
          <StepLabel />
        </Step>
      );
    });

  return (
    <ThemeProvider theme={theme}>
      <Stepper activeStep={onDecisionPage ? totalSteps.length : currentStepIndex} alternativeLabel>
        {totalSteps}
      </Stepper>
    </ThemeProvider>
  );
};

export default StepperV2;